import React from 'react'

const Vedios = () => {
  return (
    <div>Vedios</div>
  )
}

export default Vedios